import { useEffect, useState } from "react";
import { CognitoUserPool } from "amazon-cognito-identity-js";

const useUserCanQuote = ()=>{
  const [userGroups, setUserGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  const getUserGroups =()=> {
    setLoading(true);
    const USER_POOL_CONFIG = {
      UserPoolId: process.env.REACT_APP_USER_POOL_ID,
      ClientId: process.env.REACT_APP_APP_CLIENT_ID,
    };
    const userPool = new CognitoUserPool(USER_POOL_CONFIG);
    const cognitoUser = userPool.getCurrentUser();
    if (cognitoUser !== null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          console.error("Error obteniendo la sesión:", err);
          setLoading(false);
          return;
        }
        if (session) {
          const idToken = session.getIdToken().getJwtToken();
          const decodedToken = decodeJWT(idToken);
          const groups = decodedToken['cognito:groups'] || [];
          setUserGroups(groups);
          setLoading(false);
          return;
        }
      });
    } else {
      setLoading(false);
      console.log("No hay un usuario logeado.");
    }
  }

  function decodeJWT(token) {
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('El token JWT no es válido');
    }
    const payload = parts[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
    const decodedPayload = atob(padded);
    const decodedObject = JSON.parse(decodedPayload);
    return decodedObject;
  }

  useEffect(() => {
    getUserGroups();
  }, []);

  const validUserGroups = process.env.REACT_APP_GRUPOS_VALIDOS_PARA_COTIZAR;
  return userGroups.some(elemento => validUserGroups.includes(elemento));
};
export default useUserCanQuote;